import { render, staticRenderFns } from "./BracketsWinnerDialog.vue?vue&type=template&id=81acecc2&scoped=true"
import script from "./BracketsWinnerDialog.vue?vue&type=script&lang=js"
export * from "./BracketsWinnerDialog.vue?vue&type=script&lang=js"
import style0 from "./BracketsWinnerDialog.vue?vue&type=style&index=0&id=81acecc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81acecc2",
  null
  
)

export default component.exports